import { useEffect, useRef } from "react";
import styles from "./SearchComp.module.scss";
import Autocomplete from "../Autocomplete";
import { useRouter } from "next/compat/router";
import Srcset from "@/components/common/Srcset";
import { debounce } from "lodash";
// import instantsearch from "instantsearch.js";
import algoliasearch from "algoliasearch/lite";
import { useDispatch } from "react-redux";
import { setSearchIcon } from "@/redux/actions/headerAction";
import { retainFocusInsideDrawer } from "@/helpers/adaHelper";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

const SearchComp = (props) => {
  const dispatch = useDispatch();
  const { searchRef, handleSearchClick, searchActive } = props;
  const searchOpenRef = useRef(searchActive);
  const router = useRouter();
  const isDesktop= useMediaQuery("(min-width: 1025px)");
  useEffect(() => {
    if (searchActive) {
      handleSearchClick();
    }
  }, [router.asPath]);

  const handleClickSearchClose = () => {
    if (handleSearchClick) {
      handleSearchClick();
      //  if user click on close icon then set search icon to false in redux store
      dispatch(setSearchIcon(false))
    }
  };

  const handleKeyDown = (e) => {
    if(e?.key == 'Escape'){
      props.setSearchActive(false)
    }
  }

  useEffect(() => {
    searchOpenRef.current = searchActive;
    if(searchActive&&isDesktop) {
      setTimeout(() => {
        //keep search input box focus when search component is opened
        const targetEle = document?.querySelector(".auto-searchBar");
        if(document?.activeElement?.className.match("search_wrapper")){
          targetEle?.classList.add("focusElement");
          targetEle?.focus();
          targetEle?.addEventListener("keydown",(e)=>{
            if(e?.key==="Tab"){
              targetEle?.classList.remove("focusElement");
            }
          })
        }
      },0);
    }
  }, [searchActive,isDesktop])
  

  // ADA: Tab indexing 
  useEffect(() => {
    if(isDesktop){
      const node = searchRef.current;
      if (node) {
        // on focusout, add the focus back to the drawer if drawer is open
        node.addEventListener('focusout', (e) => retainFocusInsideDrawer(e, searchRef, searchOpenRef.current));
      }

      return () => {
        if (node) {
          node.removeEventListener('focusout', (e) => retainFocusInsideDrawer(e, searchRef, searchOpenRef.current));
        }
      };
    }
  }, [isDesktop]);

  // Add event listener to detect clicks outside the search wrapper
useEffect(() => {
  const handleClickOutside = (event) => {
    const searchIconDesktop = document.getElementById('search-icon-desktop');
    const excludedElement = document.querySelector('.desktop_header_icon.search-icon-mobile');
    const quickBuyDropdown = document.querySelector('.quick-buy-popup .popup');
    const sizeGuidePopUp = document.querySelector('.size-guide-popup .popup')
    const clickedOutsidePopUpOpened = document.querySelector('.quick-buy-popup .overlay')
    const clickedOutsideSizeGuideOpened = document.querySelector('.size-guide-popup .overlay')

    // Check if the click is outside the search drawer or on the search icon
    if (
      searchActive &&
      searchRef.current &&
      (!searchRef.current.contains(event.target) ||
        event.target === searchIconDesktop) &&
        !(excludedElement && excludedElement.contains(event.target)) && // Exclude the specific element and its children
        !(quickBuyDropdown && quickBuyDropdown.contains(event.target)) && // Exclude quick-buy dropdown and its children
        !(sizeGuidePopUp && sizeGuidePopUp.contains(event.target)) && //Exclude size guide pop up and its children 
        !(clickedOutsidePopUpOpened && clickedOutsidePopUpOpened.contains(event.target)) && //Exclude overlay and its children
        !(clickedOutsideSizeGuideOpened && clickedOutsideSizeGuideOpened.contains(event.target)) //Exclude overlay and its children
    ) {
      handleClickSearchClose();
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [searchActive, searchRef]);

  return (
    <div
      className={`${styles.search__container} search_wrapper`}
      ref={searchRef}
      style={props.style}
      tabIndex={-1}
      onKeyDown={handleKeyDown}
    >
      <div className={`${styles.search_wrap}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.search__wrapper}`}>
            <div className={`${styles.input_wrapper} input__wrapper`}>
              <Autocomplete
                handleSearchClick={handleSearchClick}
                searchActive={searchActive}
              />
            </div>
          </div>
        </div>
        <div
          className={`${styles.close_search}`}
          onClick={handleClickSearchClose}
        >
          <Srcset
            tabIndex={0}
            svgFile={true}
            src={"images/Icons/Cross/Large.svg"}
            requirePath={true}
            height="15"
            width="15"
            alt="cross"
            className={`search_cross_icon ${styles.cross_icon}`}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchComp;
